export const WIDTH_HEIGHT = new Set(["width", "height"]);
//# sourceMappingURL=constants.js.map